import { useTranslation } from "react-i18next"
import { goalbankSelectionItems, printDiv, translateGradeLevel } from "utils/helpers"
import SyllabusGradingChart from "./SyllabusGradingChart"
import _ from "lodash"

import beeTransparent from 'assets/images/student/bee-transparent.png'
import mathCover from 'assets/images/student/math.jpg'
import mainIdeasImage from 'assets/images/student/main-ideas.png'
import { EventNote, Schedule, Sms } from "@mui/icons-material"
import classroom from 'assets/images/classroom.jpg'

const SyllabusPresentation = ({ entity, popup=false }) => {

  const { t } = useTranslation()

  
  const chartData = _.orderBy(entity.syllabus_components, ['importance'], ['desc']).filter(g => g.importance > 0).map((g) => {
    return [g.title, g.importance]
  })
  


  const assessmentData = [
    {
      title: t('common.skill-practice'),
      percent: 40,
      color: '#0088FE',
    },
    {
      title: t('common.formative-assessment'),
      percent: 30,
      color: '#00C49F',
    },
    {
      title: t('common.summative-assessment'),
      percent: 20,
      color: '#FFBB28',
    },
    {
      title: t('common.attendance'),
      percent: 10,
      color: '#ca31f5',
    }
  ]

  const mainIdeas = goalbankSelectionItems(entity.goalbank_selection,'highlights')


  return (
    <> 
    <style dangerouslySetInnerHTML={{__html: `
      body {
        background-image: url(${classroom}) !important;
        background-position: top right 80px;
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-color: #fcfcfc !important;
      }
    `}} />


      <div id="syllabus-template"  style={{ paddingRight: popup ? '0px' : '100px', marginTop: '50px' }}>
        <div className="syllabus-head"
          style={{ 
              display: 'flex',
              width: '100%',
              background: '#ffd600',
              padding: '10px',
              fontSize: '20px',
              fontWeight: 'bold',
              alignItems: 'center'
          }}>
          
              <div><img src={beeTransparent} style={{ display: 'block', maxHeight: '140px' }}/></div>
              <div style={{ paddingLeft: '20px' }}>
                <div>{t('common.mathematics')}</div>
                <div>{translateGradeLevel(entity.course?.grade_level)}</div>
              </div>
        </div>

        <div style={{ height: '20px', background: '#fcfcfc' }}></div>

        <div className='syllabus-row'>
            <div className="syllabus-left">
              <div style={{ padding: '5px 10px' }}>
                <div dangerouslySetInnerHTML={{ __html: entity.contact_information }} />
              </div>
              
              <div style={{ height: '20px', background: '#fcfcfc' }}></div>

              <div style={{ padding: '10px', background: '#f5f5f5' }}>
                  <div style={{ fontWeight: 'bold', textAlign: 'center'  }}>{ t('syllabuses.grading-plan') }</div>
                  <div style={{ position: 'relative', top: '0px', margin: 'auto', width: '300px', height: '250px' }}>
                      <SyllabusGradingChart chartData={chartData} height={250} />
                  </div>
              </div>

              <div style={{ padding: '5px 10px', background: '#f5f5f5', paddingTop: '20px', borderTop: '1px solid #ccc' }}>
                <div style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '20px'  }}>{ t('syllabuses.assessment-principles') }</div>
                {assessmentData.filter(a => a.percent>0).map((a,idx) => <div key={idx} style={{ marginBottom: '10px' }}>
                    <div style={{ marginBottom: '2px',fontWeight: 'bold', fontSize: '14px' }}>{a.title}</div>
                    <div style={{ 
                      background: '#ccc', 
                      borderRadius: '5px',
                      height: '20px',
                      overflow: 'hidden',
                      }}>
                        <div style={{ 
                          background: a.color,
                          height: '20px',
                          position: 'relative',
                          textAlign: 'right',
                          color: '#fff',
                          fontSize: '12px',
                          lineHeight: '20px',
                          fontWeight: 'bold',
                          paddingRight: '1px',
                          maxWidth: (a.percent+10)+'%'
                        }}>
                          {a.percent}%
                        </div>
                  </div></div>)}
              </div>

              <div style={{ height: '20px', background: '#fcfcfc' }}></div>   

              <div style={{ padding: '10px' }}>
                  <div style={{ fontWeight: 'bold', textAlign: 'center'  }}>{ t('syllabuses.course-materials') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.course_materials }} />
              </div>

            </div>

                       
            <div style={{ width: '20px',background: '#fcfcfc' }}></div>

            <div className="syllabus-right">

                <div style={{ padding: '27px 40px', background: '#57bab2'  }}>
                  
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div><div style={{ 
                      background: '#fff', 
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      color: '#000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}><Schedule /></div></div>
                    <div style={{ paddingLeft: '10px', }}>
                      <div style={{ fontWeight: 'bold', fontSize: '20px', fontFamily: 'Newsreader' }}>{t('common.syllabus-title-1')}</div>
                      <div style={{ fontWeight: '300', fontSize: '14px' }}>{t('common.syllabus-text-1')}</div>
                    </div>
                  </div>
                  
                </div>

                <div style={{ height: '20px', background: '#fcfcfc' }}></div>

                <div style={{ padding: '27px 40px', background: '#9dc62b'  }}>
                  
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div><div style={{ 
                      background: '#fff', 
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      color: '#000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}><EventNote /></div></div>
                    <div style={{ paddingLeft: '10px', }}>
                      <div style={{ fontWeight: 'bold', fontSize: '20px', fontFamily: 'Newsreader' }}>{t('common.syllabus-title-2')}</div>
                      <div style={{ fontWeight: '300', fontSize: '14px' }}>{t('common.syllabus-text-2')}</div>
                    </div>
                  </div>

                </div>

                <div style={{ height: '20px', background: '#fcfcfc' }}></div>

                <div style={{ padding: '27px 40px', background: '#ecc232'  }}>
                  
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div><div style={{ 
                      background: '#fff', 
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      color: '#000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}><Sms /></div></div>
                    <div style={{ paddingLeft: '10px', }}>
                      <div style={{ fontWeight: 'bold', fontSize: '20px', fontFamily: 'Newsreader' }}>{t('common.syllabus-title-3')}</div>
                      <div style={{ fontWeight: '300', fontSize: '14px' }}>{t('common.syllabus-text-3')}</div>
                    </div>
                  </div>

                </div>

                <div style={{ height: '20px',background: '#fcfcfc' }}></div>      

                <div style={{ padding: '10px 40px', fontWeight: 300 }}>
                  <div dangerouslySetInnerHTML={{ __html: entity.homework_policy }} />
                </div>

                <div>
                  <img src={mathCover} style={{ width: '100%' }} />
                </div>
                
                {mainIdeas &&
                <div style={{ 
                  minHeight: '100px',
                  backgroundColor: '#333',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '60px auto',
                  backgroundPosition: 'center right 50px',
                  backgroundImage: `url(${mainIdeasImage})` 
                }}>
                    <ul>
                      {mainIdeas.map(h => <li>{h.title }</li>)}
                    </ul>
                </div>
                }     

            </div>
        </div>
      </div>           
                  
    </>
  )
}

export default SyllabusPresentation
